jQuery(document).ready(function ($) {
  function chooseSelectHandler() {
    jQuery(".wpcf7 .form-control")
      .focus(function () {
        jQuery(this).closest(".form-group").addClass("active")
      })
      .blur(function () {
        var cval = jQuery(this).val().trim().length
        if (cval === 0) {
          jQuery(this).closest(".form-group").removeClass("active")
        }
      })

    var $servicesSelect = $("#servicesSelect")
    var selectedText = $("#tab_nav li.active a").text()

    if ($servicesSelect.length > 0) {
      $servicesSelect
        .find('option[value="' + selectedText + '"]')
        .prop("selected", true)
        .trigger("click")
        .closest(".form-group")
        .addClass("active")
    }

    const contactText = {
      "Company Purchase":
        "to discuss your company purchase requirements and embark on a transformative growth journey.",
      "Company Sale":
        "today to discuss your company sale requirements and experience the expertise and support needed to maximize your returns.",
      "Raising Capital":
        "today to discuss your capital raising requirements and embark on a transformative journey towards fueling your business growth.",
      "Debt Advisory":
        "today to discuss your debt management and financing needs, and let us help you navigate the complex financial landscape.",
      "Valuation & Financial Modeling":
        "today to discuss your valuation and financial modeling needs, and let us help you gain a deeper understanding of your business's value and potential.",
      "Due Diligence":
        "today to discuss your due diligence requirements and leverage our expertise and meticulous approach.",
      "Advising Private Equity":
        "to discuss your private equity advisory needs and leverage our expertise and industry insights.",
    }

    $(".services-contact .wp-block-heading em").text(contactText[selectedText])
  }
  if ($("#tab_container").length > 0) {
    // Show the default tab or the one specified in hash
    var hash = window.location.hash
    if (hash) {
      $(".tab-content").removeClass("active")
      $(hash).addClass("active")
      $('a[href="' + hash + '"]')
        .parent()
        .addClass("active")
    } else {
      $(".tab-content:first").addClass("active")
      $("#tab_nav li:first").addClass("active")
    }

    chooseSelectHandler()

    // Handle tab clicks
    $("#tab_nav li a").click(function (e) {
      e.preventDefault()

      // Get the ID of the clicked tab and update the URL hash
      var tabId = $(this).attr("href")
      history.pushState(null, null, tabId)

      // Hide all tab contents except the active one
      $(".tab-content.active").fadeOut(400, function () {
        $(this).removeClass("active")
      })

      // Show the clicked tab content with a fade effect
      $(tabId).fadeIn(400, function () {
        $(this).addClass("active")
      })

      // Update the active class on the tab links
      $("#tab_nav li").removeClass("active")
      $(this).parent().addClass("active")

      $tabContentHeight = $("#tab_container").offset().top
      // console.log($('#tab_container').offset().top)
      window.scrollTo(0, $tabContentHeight)

      chooseSelectHandler()
    })
  }

  if ($("#tab_container").length > 0) {
    window.onscroll = function () {
      stickyFunction()
    }
  }

  var element = document.querySelector(".tab-nav-wrap-wrap")

  if (element) {
    var container = document.getElementById("tab_container")
    var offset = container.offsetTop
  }

  function stickyFunction() {
    if (window.scrollY >= offset) {
      element.classList.add("sticky")
    } else {
      element.classList.remove("sticky")
    }
  }
})
